import React from 'react';
import { Link } from 'react-router-dom';

const linkClass =
  'text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors';

/** Shared typography for legal pages — explicit light/dark (no @tailwindcss/typography required). */
const articleClass = [
  'text-base leading-relaxed text-gray-700 dark:text-gray-300',
  '[&_p]:mb-4 [&_p:last-child]:mb-0',
  '[&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:sm:text-2xl [&_h2]:font-bold',
  '[&_h2]:text-gray-900 [&_h2]:dark:text-white',
  '[&_h2:first-child]:mt-0',
  '[&_ul]:mb-4 [&_ul]:pl-5 [&_ul]:sm:pl-6 [&_ul]:list-disc [&_ul]:space-y-2',
  '[&_ol]:mb-4 [&_ol]:pl-5 [&_ol]:sm:pl-6 [&_ol]:list-decimal [&_ol]:space-y-2',
  '[&_li]:text-gray-700 [&_li]:dark:text-gray-300',
  '[&_strong]:font-semibold [&_strong]:text-gray-900 [&_strong]:dark:text-white',
  '[&_a]:text-red-600 [&_a]:dark:text-red-400 [&_a]:underline [&_a]:underline-offset-2',
  '[&_a:hover]:text-red-700 [&_a:hover]:dark:text-red-300',
].join(' ');

export function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-10 sm:py-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="text-sm text-gray-500 dark:text-gray-400 mb-2" aria-label="Breadcrumb">
          <Link to="/" className={`${linkClass} text-gray-500 dark:text-gray-400`}>
            Home
          </Link>
          <span className="mx-1.5 text-gray-400 dark:text-gray-600">/</span>
          <span className="text-gray-700 dark:text-gray-200">{title}</span>
        </nav>

        <h1 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white tracking-tight mb-2">
          {title}
        </h1>

        {lastUpdated ? (
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">Last updated: {lastUpdated}</p>
        ) : (
          <div className="mb-8" />
        )}

        <article className={articleClass}>{children}</article>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
          <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-500 mb-3">
            Legal
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <Link to="/privacy" className={linkClass}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={linkClass}>
              Terms of Service
            </Link>
            <Link to="/responsible-gaming" className={linkClass}>
              Responsible Gaming
            </Link>
            <Link to="/cookies" className={linkClass}>
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LegalPageLayout;
